import { useSelectedPaymentProfiles } from './use-selected-payment-profiles'

/**
 * Liga um `PaymentProfileFilter mode="multi"` à seleção múltipla global (`useSelectedPaymentProfiles`).
 * Todos os filtros multi compartilham o mesmo store, garantindo seleção única e global.
 */
export function useSelectedPaymentProfilesBinding() {
  const { selectedProfileIds, setSelectedProfileIds } = useSelectedPaymentProfiles()

  return { value: selectedProfileIds, onChange: setSelectedProfileIds }
}
